import React from 'react';

const NebulaPerfFeeAmortizedFormModal = React.lazy(() => import('../components/FormModal'));
const nebulaPerfFeeAmortizedModalRegistry = {
    personalize_nebulaPerfFeeAmortizedId: NebulaPerfFeeAmortizedFormModal
};
export default nebulaPerfFeeAmortizedModalRegistry;
